// extracted by mini-css-extract-plugin
export default {"MenuToggle":"MenuToggle_MenuToggle__0LjNW","inPanel":"MenuToggle_inPanel__U4RAi"};